import { Button } from "antd";
import { useCallback } from "react";
import { useSubmitTeamToSeason } from "../../entities/api";

const AddTeamToSeasonButton = ({ entityId }) => {
  const { mutate: addTeamFn, isPending } = useSubmitTeamToSeason();

  const submitTeamToSeason = useCallback(() => {
    addTeamFn({
      status: "ACTIVE",
      entityId: entityId,
    });
  }, [addTeamFn, entityId]);

  return <Button onClick={submitTeamToSeason} loading={isPending} icon={<i className="fas fa-plus" />} size="small" />;
};

export default AddTeamToSeasonButton;
